<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('listeOrdreTravailAffichage.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <faces-informations :ordresTravail="ordresTravail"></faces-informations>
    <div class="columns is-multiline level">
      <div class="level-left">
        <div class="column is-narrow">
          <selecteur-action
            @handleAction="manageActions"
            :options='actions'
            :placeholder='$t("general.placeHolder.groupedAction")'
            :titleButton="'general.button.apply'"
            :elementsSelectionnes="getAllOTSelected().length > 0"
          ></selecteur-action>
        </div>
        <div class="column is-narrow">
          <form @submit.prevent="recherche()">
            <b-input :placeholder="$t('listeOrdreTravailAffichage.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
        </div>
        <div class="column is-narrow">
          <button class="button" @click="setShowFiltre">
            <b-icon icon="filter-variant" size="is-small" type="is-default"/>
            <span class="is-size-7">
              {{$t('general.button.filtre')}}
              <label
                class="has-text-weight-bold"
                :class="nombreCritere > 0 ? '' : 'is-invisible'">
                ({{ nombreCritere }})
              </label>
            </span>
          </button>
          <span
            class="info-circle-right is-pulled-right is-cursor-pointer"
            @click="reinitialiserFiltre()">
            <b-icon icon="close-circle" type="is-danger"/>
          </span>
        </div>
        <div class="column is-3">
          <b-datepicker show-week-number
                        icon="calendar-today"
                        :editable="true"
                        @input="recherche"
                        v-model="periode"
                        :date-formatter="formatageOuputDatepicker"
                        range
                        :nearby-selectable-month-days="true">
          </b-datepicker>
        </div>
      </div>
      <div class="level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permsOrdreTravail.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <a ref="lienDownload"></a>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"/>
      </div>
      <div slot="code" slot-scope="props">
        <router-link
          :to="{ name: 'c.logistique.ordre_travail-affichage', params: {id: props.row.id}}"
          class="lien"
          :class="{'text-access-no-permission': !checkPermissions(permsOrdreTravail.lecture)}">
          {{props.row.code}}
        </router-link>
      </div>
      <div slot="afficheur" slot-scope="props">
        {{ props.row.intervenants ? props.row.intervenants[0].nomCommercial : '' }}
      </div>
      <div slot="dateDevisCommande" slot-scope="props">
        {{ props.row.dateDevisCommande | formatDate }}
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getEtat(props.row.etat)) }}
      </div>
      <div slot="exporter" slot-scope="props" >
        <a @click="checkPermissions(permsOrdreTravail.editer) ?
          edition({format: pdf,
                      typeDonnee: typeEditionOt}, props.row.id) : showPopUp()">
          <b-icon
            :key="props.id"
            icon="file-pdf-box"
            type="is-primary"
            :class="{'text-access-no-permission' : !checkPermissions(permsOrdreTravail.editer)}">
          </b-icon>
        </a>
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId) }}
      </div>
      <div slot="edit" slot-scope="props">
        <router-link
          :class="{'disabled': props.row.etat === constantes.ETAT_CLOTURER }"
          :to="{ name: 'm.logistique.ordre_travail-affichage', params: { id: props.row.id} }">
          <b-icon icon="pencil-box-outline"
                  :type="{ 'is-success': props.row.etat !== constantes.ETAT_CLOTURER }"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(permsOrdreTravail.maj)
                      && props.row.etat !== constantes.ETAT_CLOTURER }"></b-icon>
        </router-link>
      </div>
      <div slot="archive" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(permsOrdreTravail.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="archive" type="is-default"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsOrdreTravail.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="props">
        <div @click="checkPermissions(permsOrdreTravail.supprimer) ? openPopUpDelete(props.row) :
            showPopUp()"
             :class="{'disabled': props.row.etat === constantes.ETAT_CLOTURER }"
             class="is-cursor-pointer">
          <b-icon icon="delete-forever"
                  :type="{ 'is-danger': props.row.etat !== constantes.ETAT_CLOTURER }"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(permsOrdreTravail.supprimer) }"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-ordre-travail
        ref="filtreOrdreTravail"
        @toggleFiltre="setShowFiltre"
        @recherche="makeRechercheFilter"/>
    </div>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition="getListeChoiceEdition"
        @editionChoose="editionOrdreTravail"
      >
      </pop-up-edition>
    </b-modal>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="idToDelete.length === 1
          ? this.$t('listeOrdreTravailAffichage.popUpSuppression.title')
          : this.$t('listeOrdreTravailAffichage.popUpSuppression.titleMutlti')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        :messagesPopup="messagesPopUp"
        :isErrorPopup.sync="isErrorPopUp"
        @no="popUpSuppression = false"
        @yes="deleteOtMass()"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import inProgress from '@/services/general/inProgress';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import selecteurAction from '@/components/general/selecteurAction';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  LISTE_ETAT_ORDRE_TRAVAIL,
  TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE,
  LISTE_CHOICE_EDITION_OT, ETAT_CLOTURER, OT_AVEC_RESEAU,
  EXPORT_EXCEL_ORDRE_TRAVAIL_AFFICHAGE,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import formatDate from '@/services/general/formatIsoDate';
import formatDateFr from '@/services/general/formatDate';
import filtreOrdreTravail from '@/components/logistique/ordreTravail/affichage/filtre/filtreOrdreTravail';
import { ACTION_MASS_EDITION, ACTION_MASS_DELETE } from '@/configuration/general/actionsConf';
import popUpEdition from '@/components/logistique/ordreTravail/affichage/p_edition';
import edition from '@/api/edition';
import popUpPrevention from '@/components/general/popUpPrevention';
import { deleteAllOt } from '@/api/logistique/ordreTravailAffichage';
import messageSucces from '@/services/general/messageSucces';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import { SET_DATE_SELECT } from '@/store/modules/logistique/demande-mutation-type';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import facesInformations from '@/components/logistique/ordreTravail/affichage/facesInformations';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import transformer from '@/services/general/filters/serverTableDataTransformer';
import validation from '@/services/logistique/ordreTravail/affichage/validation';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_ORDRE_TRAVAIL_AFFICHAGE } from '@/configuration/general/referenceTableConf';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import validationEdition from '@/services/general/validation/validationRetourEdition';

const OrdreTravail = createNamespacedHelpers('ordreTravailAff');
const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Demande = createNamespacedHelpers('demande');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      actions: [
        { action: ACTION_MASS_EDITION, translation: 'listeOrdreTravailAffichage.actions.editionMasse' },
        { action: ACTION_MASS_DELETE, translation: 'listeOrdreTravailAffichage.actions.delete' },
      ],
      unsubscribeValue: null,
      showFiltre: false,
      permsOrdreTravail: ORDRE_TRAVAIL,
      popUpEdition: false,
      popUpSuppression: false,
      idToDelete: [],
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      pdf: TYPE_PDF,
      typeEditionOt: TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE,
      constantes: {
        ETAT_CLOTURER,
      },
      messagesPopUp: [],
      isErrorPopUp: false,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      referenceTable: REFERENCE_TABLE_ORDRE_TRAVAIL_AFFICHAGE,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    breadcrumb,
    selecteurAction,
    TableItemsInView,
    filtreOrdreTravail,
    popUpEdition,
    popUpPrevention,
    facesInformations,
    parametrageTable,
    exportExcelButton,
  },
  computed: {
    ...OrdreTravail.mapGetters({
      ordresTravail: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
      agencesInformations: 'agencesInformations',
      societesInformations: 'societesInformations',
      lockMenu: 'lockMenu',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    periode: {
      get() {
        return this.critereRecherche.periode;
      },
      set(val) {
        this.setDateSelect(val[0]);
        this.critereRecherche.periode = val;
      },
    },
    getListeChoiceEdition() {
      const listesChoice = cloneDeep(LISTE_CHOICE_EDITION_OT);
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.editionOtWithReseau.key)) {
        const indexEditionOt = listesChoice.findIndex(l => l.typeEdition === OT_AVEC_RESEAU);
        listesChoice.splice(indexEditionOt, 1);
      }
      return listesChoice;
    },
    nombreCritere() {
      let nombreCritere = 0;
      nombreCritere += this.critereRecherche.otEtat.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.afficheur.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.agencesId.length > 0 ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    breadcrumb() {
      return [
        { title: this.$t('listeOrdreTravailAffichage.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeOrdreTravailAffichage.breadcrumb.ordresTravails'), route: '', isActive: true },
      ];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('listeOrdreTravailAffichage.tabs.numberOT'),
          theme: this.$t('listeOrdreTravailAffichage.tabs.listeAffichage'),
          afficheur: this.$t('listeOrdreTravailAffichage.tabs.afficheur'),
          etat: this.$t('listeOrdreTravailAffichage.tabs.etat'),
          dateDevisCommande: this.$t('listeOrdreTravailAffichage.tabs.dateDepart'),
          nFacesPrevues: this.$t('listeOrdreTravailAffichage.tabs.nFacesPrevues'),
          nFacesAffichees: this.$t('listeOrdreTravailAffichage.tabs.nFacesAffichees'),
          nGrattageEffectues: this.$t('listeOrdreTravailAffichage.tabs.nGrattageEffectues'),
          nFacesLaisserEnPlace: this.$t('listeOrdreTravailAffichage.tabs.nFacesLaisserEnPace'),
          agence: this.$t('listeOrdreTravailAffichage.tabs.agence'),
          exporter: '',
          edit: '',
          archive: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = {
            auto: this.critereRecherche.auto,
            otEtat: this.critereRecherche.otEtat,
            agencesId: this.critereRecherche.agencesId,
            tiersId: this.critereRecherche.afficheur.map((afficheur) => {
              return afficheur.id;
            }),
            societeId: this.societeActiveId,
          };
          if (!data.query.agencesId || data.query.agencesId.length === 0) {
            if (this.agencesSelectionnees.length === 1
              && this.agencesSelectionnees.length === this.societeActive.agences.length) {
              delete data.query.agencesId;
            } else {
              data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
            }
          }
          if (data.query.otEtat.length === 0) delete data.query.otEtat;
          if (Array.isArray(this.critereRecherche.periode)) {
            data.query.dates = {
              dateDebut: formatDate(this.critereRecherche.periode[0]),
              dateFin: formatDate(this.critereRecherche.periode[1]),
            };
          } else data.query.dates = { dateDebut: formatDate(this.critereRecherche.periode) };
          return this.loadOrdreTravail(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.ordresTravail,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          exporter: 'colonneSelected',
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          selected: 'colonneSelected',
          archive: 'colonneSelected',
        },
        sortable: ['code', 'theme', 'etat', 'dateDevisCommande'],
      };
    },
    iconSelectTotal() {
      if (this.allOTSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      const columns = ['selected', 'code', 'theme', 'afficheur', 'etat', 'dateDevisCommande', 'nFacesPrevues', 'nFacesAffichees', 'nFacesLaisserEnPlace', 'nGrattageEffectues', 'agence', 'exporter', 'edit', 'archive', 'delete'];
      return columns;
    },
    allOTSelected() {
      return this.getAllOTSelected().length === this.ordresTravail.length
        && this.ordresTravail.length > 0;
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_ORDRE_TRAVAIL_AFFICHAGE,
        typeExport: '',
        filtres: transformer(this.lastPayload),
      };
    },
  },
  methods: {
    ...OrdreTravail.mapActions({
      loadOrdreTravail: 'loadOrdreTravail',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Demande.mapMutations({
      setDateSelect: SET_DATE_SELECT,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async edition(donnees, id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) this.$refs.filtreOrdreTravail.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    reinitialiserFiltre() {
      this.$refs.filtreOrdreTravail.initializeFiltre();
      this.$refs.filtreOrdreTravail.viderCritere();
      this.$refs.filtreOrdreTravail.appliquerCritere();
      this.showFiltre = false;
    },
    manageActions(action) {
      if (action === ACTION_MASS_EDITION) {
        if (this.checkPermissions(this.permsOrdreTravail.editer)) {
          this.openPopupEdition();
        } else this.showPopUp();
      }
      if (action === ACTION_MASS_DELETE) {
        if (this.checkPermissions(this.permsOrdreTravail.supprimer)) {
          this.popUpSuppression = true;
          this.idToDelete = this.ordresTravail.filter((el) => {
            return el.selected;
          }).map((el) => { return el.id; });
        } else this.showPopUp();
      }
    },
    openPopUpDelete(ot) {
      this.popUpSuppression = true;
      this.idToDelete = [ot.id];
    },
    getAgenceLibelle(agenceId) {
      let libelleAgence = '';
      this.societesInformations.forEach((societe) => {
        societe.agences.forEach((agence) => {
          if (agence.id === agenceId) libelleAgence = agence.libelle;
        });
      });
      return libelleAgence;
    },
    async deleteOtMass() {
      this.messagesPopUp = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteAllOt(this.idToDelete);
        this.popUpSuppression = false;
        messageSucces(this.idToDelete.length === 1
          ? this.$t('listeOrdreTravailAffichage.messages.success.otDelete') : this.$t('listeOrdreTravailAffichage.messages.success.otMulti'));
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          this.isErrorPopUp = true;
          validation(e.response, this.messagesPopUp);
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    openPopupEdition() {
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      this.popUpEdition = true;
    },
    async editionOrdreTravail(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      try {
        const response = await edition({
          ids: this.ordresTravail.filter((el) => {
            return el.selected;
          }).map((el) => { return el.id; }),
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationEdition(response, this.errorEdition.messages);
          this.errorEdition.haveError = true;
          this.isError = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getAllOTSelected() {
      return this.ordresTravail.filter((el) => {
        return el.selected;
      });
    },
    selectAll() {
      const select = !this.allOTSelected;
      this.ordresTravail.forEach(item => {
        item.selected = select;
      });
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getEtat(etat) {
      const etatFind = LISTE_ETAT_ORDRE_TRAVAIL.find((devisCommandeEtat) => {
        return devisCommandeEtat.code === etat;
      });
      return etatFind ? etatFind.libelle : '';
    },
    formatageOuputDatepicker() {
      const dateDebut = moment(this.critereRecherche.periode[0]).startOf('week').toDate();
      const dateFin = this.critereRecherche.periode[1];
      return formatDateFr(dateDebut) + ' - ' + formatDateFr(dateFin);
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.editionOtWithReseau.key]);
      this.setInformationPage(this.$t('pageLogistique.ot.listeAff'));
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
